import Axios from "axios";

export const SelectAllReleveClient = ( a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/ReleveClient?idcli&coddoss=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "RELEVERCLI_GET", payload: response.data });
    });
  };
};

